require('./src/components/reset.css');
require('./src/components/swiper.min.css');
require('./src/components/bootstrap-grid.min.css');
require('./src/components/slick.css');
require('./src/static/facebook-pixel.js');
const {initAmplitudeAnalytics} = require('./src/utils/init-amplitude-analytics.js');
const {initDatadogRum} = require('./src/utils/init-datadog-rum');

if (!('IntersectionObserver' in window)) {
  require('intersection-observer');

  require('custom-event-polyfill');
}

exports.onClientEntry = () => {
  initDatadogRum({service: 'career-web'});
  initAmplitudeAnalytics();
};
